export enum ProductIdentificationSource {
    ToPick,
    Replacement,
}
